'use client';

import { FormattedMessage, useIntl } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import AppIcon from '@alltrails/denali/components/AppIcon';
import Heading from '@alltrails/denali/components/Heading';
import AppsFlyerQrCode from '@alltrails/install-prompt/components/AppsFlyerQrCode/AppsFlyerQrCode';
import AppStore from '@alltrails/layout/components/Footer/StoreBadges/AppStore';
import GooglePlay from '@alltrails/layout/components/Footer/StoreBadges/GooglePlay';
import type { TrailId } from '@alltrails/types/TrailId';
import styles from './TrailAppInstall.module.scss';

type TrailAppInstallProps = {
  trailId: TrailId;
};

// https://www.figma.com/design/of9BVPuMqzjbOWZMEDcGxX/New-User-Journey-2026?node-id=3019-103215
const TrailAppInstall = ({ trailId }: TrailAppInstallProps) => {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();

  return (
    <div className={styles.container}>
      <div className={styles.intro}>
        <AppIcon size={64} />
        <div className={styles.copy}>
          <Heading as="h2" size="400">
            <FormattedMessage defaultMessage="Adventure starts in the app" />
          </Heading>
          <Typography color="secondary" variant="text200">
            <FormattedMessage defaultMessage="Offline maps, navigation, and conditions — all in one place" />
          </Typography>
        </div>
      </div>
      <div className={styles.actions}>
        <div className={styles.badges}>
          <AppStore height={48} intl={intl} languageRegionCode={languageRegionCode} />
          <GooglePlay height={48} intl={intl} languageRegionCode={languageRegionCode} />
        </div>
        <span className={styles.divider} />
        <AppsFlyerQrCode trailId={trailId} />
      </div>
    </div>
  );
};

export default TrailAppInstall;
